import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { StoreModule } from '@ngrx/store'
import { EffectsModule } from '@ngrx/effects'

import { RentalEffects } from './rental.effects'
import * as fromRental from './rental.reducer'
import { SubdomainGuard } from './subdomain.guard'
import { RentalRatesGuard } from './rental-rates.guard'
import { RentalService } from './rental.service'
import { RateMappingService } from './rental-rate-mapping.service'
import { RentalRateMappingEffects } from './rental-rate-mapping.effects'
import { IsMainUnitPipe, IsSubunitPipe, IsParentRentalPipe, IsChildRentalPipe } from './rental.pipes'
import { DeleteRentalService } from './delete-rental.service'

const pipes = [IsMainUnitPipe, IsSubunitPipe, IsParentRentalPipe, IsChildRentalPipe]

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('rental', fromRental.rentalReducer),
    EffectsModule.forFeature([
      //
      RentalEffects,
      RentalRateMappingEffects,
    ]),
  ],
  providers: [
    //
    RateMappingService,
    RentalService,
    DeleteRentalService,
    SubdomainGuard,
    RentalRatesGuard,
    ...pipes,
  ],
  declarations: [...pipes],
  exports: [...pipes],
})
export class RentalStoreModule {}
